module.exports = __webpack_public_path__ + "images/icon-stockist-rapid.ce9bfd.svg";